var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses},[_vm._t("default"),_c('text-content',{staticClass:"pc-dashboard__card-empty-text",attrs:{"weight":'normal',"line-height":'single',"size":'sm1'}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }